document.addEventListener('DOMContentLoaded', () => {

    const sliderSwiper = new Swiper('.slider-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		pagination: {
			el: ".sw-bullets",
			clickable: true,
		}
	});

	const cardsSwiper = new Swiper('.cards-swiper', {
		loop: true,
		speed: 800,
		spaceBetween: 10,
        navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			650: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 4,
			}
		}
	});

	const centeredSwiper = new Swiper('.centered-swiper', {
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 15,
		loop: true,
		speed: 800,
        navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		}
	});

	const gallerySwiper = new Swiper('.gallery-swiper', {
		loop: true,
		spaceBetween: 15,
		speed: 800,
		autoplay: {
			delay: 3000,
		},
        navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			700: {
				slidesPerView: 3,
			}
		}
	});

	const imgSliderSwiper = new Swiper('.top-reasons-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		pagination: {
			el: ".sw-bullets",
			clickable: true,
		}
	});

	const reviewSwiper = new Swiper('.reviews-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		autoplay: {
			delay: 8000,
		},
		pagination: {
			el: ".sw-bullets",
			clickable: true,
		}
	});
	
});